import { useCallback, useContext } from 'react'
import { useParams } from 'react-router'

import { useMutation } from '@apollo/client'

import { MaxViewPage } from 'tools/Uniform'

import { useNav } from 'app/Nav'
import { REQUEST_PASSWORD_RESET } from 'libreon/User/graphql'

import Password from './Change'
import EmailInput from './EmailInput'
import { PasswordContext, PasswordProvider, setPasswordMessage } from './reducer'

/*
 *  Kindof a Pita, but to stay DRY this doesn't use any Global or User Contexts,
 *  so it can be referenced both as a signed in user and anonymously to reset
 *  a password
 */

export function AuthPassword({ routeId }) {
  if (!routeId) throw new Error('AuthPassword called with no routeId')
  useNav(routeId)

  return (
    <MaxViewPage>
      <ChangePassword />
    </MaxViewPage>
  )
}

export function ChangePassword({ email, factors = {}, allowed = {} }) {
  const { userId, code } = useParams()

  const [request] = useMutation(REQUEST_PASSWORD_RESET)
  const requestReset = useCallback(
    (email, dispatch) => {
      request({
        variables: { email, id: userId },
        onCompleted({ requestPasswordReset: { success, reason } }) {
          if (success) {
            setPasswordMessage(dispatch, 'code', 'submitted')
          } else {
            setPasswordMessage(dispatch, 'code', 'reason', reason)
          }
        }
      })
    },
    [request, userId]
  )

  return (
    <PasswordProvider
      email={email}
      factors={factors}
      userId={userId}
      requestReset={requestReset}
      allowed={allowed}
      code={code}
    >
      <ChangePasswordInner />
    </PasswordProvider>
  )
}

function ChangePasswordInner() {
  const [{ id, code, factors, allowed }] = useContext(PasswordContext)

  return (
    <div className="mb4">
      {id && factors ? (
        <>
          <label className="f4 b db mb3 heading">Change Password</label>
          {!factors.password && (
            <div className="mb3">
              You are signed in with
              <b>
                {allowed.google
                  ? ' Google Authentication '
                  : ' Federated Authentication '}
              </b>
              which doesn’t use a password.
              <div className="mb2" />
              In order to set a password, you need to request a Password Reset
              Code.
            </div>
          )}
          <Password />
        </>
      ) : code.value ? (
        <Password />
      ) : (
        <EmailInput />
      )}
    </div>
  )
}
